import { BdaDataset } from "./BdaDataset";
import { Datasource } from "./Datasource";
import { AccessLevel } from "./generics";
import { Organization, Owner } from "./ControlPanel";

export type ModelLicense = {
  key: string;
  value: string;
  link: string;
}

export type ModelTask = {
  key: string;
  value: string;
  modality: string;
}

export interface BdaModel {
  accessLevel: AccessLevel;
  algorithmName: string;
  createDateTime: string;
  created: boolean;
  createdByBdaId: number;
  createdByServiceId: number;
  createdByWorkflowId: number;
  datasource: Datasource;
  description: string;
  evaluations: any[];
  format: any;
  id: number;
  inputs: string;
  label: any;
  location: string;
  mlFlowModelUrl: string;
  name: string;
  order: number;
  organization: Organization;
  owner: Owner;
  properties: any[];
  serving: any;
  tags: string[];
  targets: any;
  trainingDataset: BdaDataset;
  updateDateTime: string;
  deleteDateTime?: string;
  ref?: string;
  languages?: string[];
  license?: ModelLicense;
  task?: ModelTask;
  markDown?: {
    value: string;
  };
}

export class BdaModelDTO {
  id?: number;
  name: string;
  description: string;
  tags: string[];
  format?: string;
  location?: string;
  datasource?: Datasource;
  languages?: string[];
  license?: ModelLicense;
  task?: ModelTask;

  constructor() {
    this.name = "";
    this.description = "";
    this.tags = [];
    this.format = "";
  }
}